import {useEffect, useContext, useState} from "react";
import {MapContainer, Marker, Popup, TileLayer} from "react-leaflet";

import {MarkerIcon} from "components/maps/icons";
import {ContainerMarkerSVG} from "components/waste-icons/svgs/ContainerMarkerSVG";
import AuthContext from "context/AuthContext";
import axiApi from "ApiCaller";
import {SwalAlertClass} from "core/swalClass";
import MapResizeZoom from "components/maps/MapResizeZoom";
import {Link} from "react-router-dom";
import AzureMapBase from "components/maps/azure/AzureMapBase";
import AzureMapMarker from "components/maps/azure/AzureMapMarker";
import AzureMapPopup from "components/maps/azure/AzureMapPopup";
import {FitAssets, LeafletFitAssetsWrapper} from "components/maps/FitIslands";
import {CARTO_TILE_URL, CARTO_TILE_OPTIONS} from 'core/mapsConfig';

const MapHomeBridge = () => {
    let {user, panel} = useContext(AuthContext);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const ZOOM = 14;
    const position = user.panel.coords;
    const [assets, setAssets] = useState([]);
    const [azureMap, setAzureMap] = useState(null);

    const handleAzureMapReady = (mapInstance) => {
        setAzureMap(mapInstance);
    };

    useEffect(() => {
        axiApi
            .get("/api/home/map/")
            .then((resp) => {
                if (resp.status) {
                    setAssets(resp.data.items);
                } else {
                    Alert.error(
                        "Server Error",
                        "Se ha encontrado un error en la carga del mapa."
                    );
                }
            })
            .catch((error) => {
                console.info(error);
                Alert.error(
                    "Server Error",
                    "Se ha encontrado un error en la carga del mapa."
                );
            });
    }, []);

    switch (panel.map_type) {
        case "az":
            return (
                <AzureMapBase center={position} zoom={ZOOM} height="520px" onMapReady={handleAzureMapReady}>
                    <FitAssets assets={assets} azureMap={azureMap}/>
                    {assets.map((asset) => (
                        <AzureMapMarker
                            position={[asset.lat ?? asset.island_lat, asset.lng ?? asset.island_lng]}
                            key={asset.id}
                        >
                            <AzureMapPopup>
                                <div className="d-inline-block">
                                    {asset.has_device ? (
                                        <Link to={"/data-view/data-container/" + asset.uid + "/"}>
                                            <ContainerMarkerSVG type={asset.waste_type} percent={asset.filling}/>
                                        </Link>
                                    ) : (
                                        <ContainerMarkerSVG type={asset.waste_type} percent={asset.filling}/>
                                    )}
                                </div>
                            </AzureMapPopup>
                        </AzureMapMarker>
                    ))}
                </AzureMapBase>
            );
        case "lf":
        default:
            return (
                <MapContainer
                    center={position}
                    zoom={ZOOM}
                    scrollWheelZoom={true}
                    style={{width: "100%", height: "520px", zIndex: "2"}}
                >
                    <MapResizeZoom position={position} zoomDefault={ZOOM}/>
                    <LeafletFitAssetsWrapper assets={assets}/>
                    <TileLayer
                        url={CARTO_TILE_URL}
                        {...CARTO_TILE_OPTIONS}
                    />
                    {assets.map((asset) => (
                        <Marker
                            position={[asset.lat ?? asset.island_lat, asset.lng ?? asset.island_lng]}
                            key={asset.id}
                            icon={MarkerIcon}
                        >
                            <Popup>
                                <div className="d-inline-block">
                                    {asset.has_device ? (
                                        <Link to={"/data-view/data-container/" + asset.uid + "/"}>
                                            <ContainerMarkerSVG type={asset.waste_type} percent={asset.filling}/>
                                        </Link>
                                    ) : (
                                        <ContainerMarkerSVG type={asset.waste_type} percent={asset.filling}/>
                                    )}
                                </div>
                            </Popup>
                        </Marker>
                    ))}
                </MapContainer>
            );
    }
};

export default MapHomeBridge;
